import { Box, Typography, TextareaAutosize, FormControl, InputLabel } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { IMultipleTextInputProps } from "~/shared/types/types";

export const MultipleTextInput = ({
  label,
  title,
  value,
  isError = false,
  minRows = 1,
  maxRows = 5,
  onChange,
  placeholder,
  style,
  ...rest
}: IMultipleTextInputProps) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" gap={0.5} sx={{ width: '100%' }}>
      <FormControl variant="outlined" fullWidth>
        {label ? <InputLabel shrink htmlFor="my-textarea">{label}</InputLabel> : null}
        {title ? <Typography fontWeight={600} variant="subtitle2">{title}</Typography> : null}
        <TextareaAutosize
          minRows={minRows}
          maxRows={maxRows}
          value={value}
          onChange={onChange}
          placeholder={placeholder ?? `До ${maxRows} строк`}
          style={{
            border: isError
              ? `1.5px solid red`
              : `1.5px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            outline: 'none',
            borderRadius: 6,
            lineHeight: '24px',
            fontFamily: theme.typography.fontFamily,
            padding: 8,
            width: '100%',
            resize: 'vertical',
            boxSizing: 'border-box',
            color: theme.palette.text.primary,
            ...style,
          }}
          {...rest}
        />
      </FormControl >
    </Box>
  );
}
